import { render, staticRenderFns } from "./ArticleDispatch.vue?vue&type=template&id=f1134fe6&name=article-list&"
import script from "./ArticleDispatch.vue?vue&type=script&lang=js&"
export * from "./ArticleDispatch.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDispatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports